// Copyright (c) Ping. All rights reserved.
//
// Web variant of the exact Figma call-control glyphs. react-native-svg has no
// runtime under react-native-web (lucide-react-native is aliased to lucide-react
// and the native SVG package is never installed on web), so the parametrised SVG
// is encoded as a `data:image/svg+xml;base64,…` URI and fed to `<Image>`. macOS
// uses the `.macos.tsx` sibling. Mirrors `icons/NavIcon.tsx`.

import { Image } from 'react-native';
import { type CallControlIconName, getCallControlIconSvg } from './callControlIconSvgs';

export interface CallControlIconProps {
	readonly name: CallControlIconName;
	readonly size?: number;
	readonly color: string;
	readonly accessibilityLabel?: string;
}

export function CallControlIcon({ name, size = 20, color, accessibilityLabel }: CallControlIconProps): JSX.Element {
	const svg = getCallControlIconSvg(name, color);
	const uri =
		typeof btoa !== 'undefined'
			? `data:image/svg+xml;base64,${btoa(svg)}`
			: `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
	return (
		<Image
			source={{ uri }}
			accessibilityIgnoresInvertColors
			accessibilityLabel={accessibilityLabel ?? name}
			style={{ width: size, height: size }}
			resizeMode="contain"
		/>
	);
}
